import React, { useState } from "react";
import FormatDateTime from "../../utils/formatDateTime";
import { MoveRightIcon, MoveLeftIcon } from "lucide-react";
import { ChevronsUpDownIcon, RefreshCcwIcon, FilterIcon } from "lucide-react";
import { handleSortOrderHistoryData } from "../../utils/sortFunctions";

export default function ForexOrdersHistoryDataTable({
  forexOrdersHistoryData,
  filteredOrdersHistoryData,
  setFilteredOrderHistoryFno,
  setFilteredOrderHistoryEquity,
  sortOrder,
  setSortOrder,
  currentState,
  allUser,
  ...props
}) {
  const [showFilter, setShowFilter] = useState(false);

  const handleRefreshData = () => {
    console.log("Handle Refresh data");
  };

  const handleShowFilter = () => {
    setShowFilter(true);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const totalPages = props.currentPage;

  const displayPageNumbers = () => {
    const pageNumbers = [];
    const maxPageButtons = 5; // You can adjust this value based on your preference

    let startPage;
    let endPage;

    if (totalPages <= maxPageButtons) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (props.currentPage <= Math.ceil(maxPageButtons / 2)) {
        startPage = 1;
        endPage = maxPageButtons;
      } else if (
        props.currentPage + Math.floor(maxPageButtons / 2) >=
        totalPages
      ) {
        startPage = totalPages - maxPageButtons + 1;
        endPage = totalPages;
      } else {
        startPage = props.currentPage - Math.floor(maxPageButtons / 2);
        endPage = props.currentPage + Math.floor(maxPageButtons / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`flex items-center justify-center text-xs  font-semibold rounded-full h-5 w-5 ${
            props.currentPage === i
              ? "bg-[#07F2C7] text-black"
              : "bg-white/10 text-white/40"
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const handlePageChange = (page) => {
    props.setCurrentPage(page);
  };

  return (
    <>
      {forexOrdersHistoryData && forexOrdersHistoryData?.length === 0 ? (
        <>
          <div className="z-0 w-full h-[calc(100vh-120px)] custom-scroll overflow-x-auto  shadow-md animate-reveal transition-all duration-500 ease-in">
            <div className="w-full h-full flex flex-col items-center justify-center text-white">
              No Trade History Found!!
            </div>
          </div>
          <div className="flex  mt-4 items-center justify-end  px-10 ">
            <div className="flex items-center  space-x-6 justify-end w-full">
              <button
                onClick={() => handlePageChange(props.currentPage - 1)}
                disabled={props.currentPage === 1}
                className=" group disabled:text-white/30  disabled:cursor-not-allowed tracking-widest flex items-center justify-center px-2 py-1  text-sm font-medium text-white rounded-sm "
              >
                <MoveLeftIcon className="h-4 w-4 text-white group-disabled:text-white/30  mr-2" />
                Prev
              </button>

              <div className="flex space-x-4 items-center justify-center ">
                {displayPageNumbers()}
              </div>

              <button
                onClick={() => handlePageChange(props.currentPage + 1)}
                disabled={
                  forexOrdersHistoryData && forexOrdersHistoryData?.length === 0
                }
                className="group disabled:text-white/30 disabled:cursor-not-allowed tracking-widest flex items-center justify-center px-2 py-1  text-sm font-medium text-white rounded-sm "
              >
                Next
                <MoveRightIcon className="h-4 w-4 text-white group-disabled:text-white/30  ml-2" />
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="z-0 w-full h-[calc(100vh-120px)] custom-scroll overflow-x-auto  shadow-md animate-reveal transition-all duration-500 ease-in">
            <div className="bg-black   text-sm w-full relative z-0 ">
              <div className=" text-sm text-left ">
                <div className="flex flex-row bg-black text-white border-b  border-white ">
                  <div className="w-[20%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "symbol"
                        )
                      }
                    >
                      Symbol
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "orderdatetime"
                        )
                      }
                    >
                      Date
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "side"
                        )
                      }
                    >
                      Side
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>

                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "qty"
                        )
                      }
                    >
                      Quantity
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "remainingquantity"
                        )
                      }
                    >
                      Remaining Quantity
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "limitprice"
                        )
                      }
                    >
                      Limit Price
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>

                  <div className="w-[10%] px-4 py-6">
                    {" "}
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "stopprice"
                        )
                      }
                    >
                      Stop Price
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>

                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "status"
                        )
                      }
                    >
                      Status
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>

                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortOrderHistoryData(
                          filteredOrdersHistoryData,
                          setFilteredOrderHistoryFno,
                          setFilteredOrderHistoryEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "strategy"
                        )
                      }
                    >
                      Strategy
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="">
                {filteredOrdersHistoryData &&
                  filteredOrdersHistoryData?.map((item, index) => {
                    const clientIdsToMark = item.clientIds;
                    return (
                      <div key={index} className="border-b border-white">
                        <div className="flex flex-row bg-black z-0  font-medium text-white hover:bg-black/90">
                          <div className="w-[20%] px-4 py-4  border-r border-white-500">
                            {item.symbol.replace("NSE:", "")}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {FormatDateTime(item.orderdatetime)}
                          </div>
                          <div
                            className={`w-[10%] px-4 py-4  border-r border-white-500 ${
                              item.side === 1
                                ? "text-emerald-600"
                                : item.side === -1
                                ? "text-rose-500"
                                : "text-blue-500"
                            }`}
                          >
                            {item.side === 1 ? "BUY" : "SELL"}
                          </div>

                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.qty}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.remainingquantity}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.limitprice}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.stopprice}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.status === 1
                              ? "CANCELLED"
                              : item.status === 2
                              ? "divADED"
                              : item.status === 4
                              ? "divANSIT"
                              : item.status === 5
                              ? "REJECTED"
                              : item.status === 6
                              ? "PENDING"
                              : item.status === 7
                              ? "EXPIRED"
                              : "STATUS UNKNOWN"}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.strategy}
                          </div>
                        </div>
                        <div className="flex flex-wrap bg-black z-0  font-medium text-white py-2">
                          {allUser &&
                            allUser?.map((ele, i) => {
                              return (
                                <div
                                  key={i}
                                  className="px-3 items-center text-base border-r border-gray-600 my-1"
                                >
                                  {clientIdsToMark.includes(ele.client_id) && (
                                    <span
                                      style={{ color: "green" }}
                                      className="mr-1"
                                    >
                                      ✔
                                    </span>
                                  )}
                                  {ele.name}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="flex  mt-4 items-center justify-end  px-10 ">
            <div className="flex items-center  space-x-6 justify-end w-full">
              <button
                onClick={() => handlePageChange(props.currentPage - 1)}
                disabled={props.currentPage === 1}
                className=" group disabled:text-white/30  disabled:cursor-not-allowed tracking-widest flex items-center justify-center px-2 py-1  text-sm font-medium text-white rounded-sm "
              >
                <MoveLeftIcon className="h-4 w-4 text-white group-disabled:text-white/30  mr-2" />
                Prev
              </button>

              <div className="flex space-x-4 items-center justify-center ">
                {displayPageNumbers()}
              </div>

              <button
                onClick={() => handlePageChange(props.currentPage + 1)}
                disabled={
                  forexOrdersHistoryData && forexOrdersHistoryData?.length === 0
                }
                className="group disabled:text-white/30 disabled:cursor-not-allowed tracking-widest flex items-center justify-center px-2 py-1  text-sm font-medium text-white rounded-sm "
              >
                Next
                <MoveRightIcon className="h-4 w-4 text-white group-disabled:text-white/30  ml-2" />
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
